import { ModalHeader } from '@components/App/Modal/components/ModalHeader'
import { ThemeColors } from '@octopus-do/octopus-storybook'
import type React from 'react'

import type { ModalProps } from '@/types'
import { clsJoin } from '@/utils'
import { UpgradeCarousel } from './components'
import { SegmentedControl } from './components/SegmentedControl'
import { UpgradeToPro } from './components/UpgradeToPro'
import { UpgradeToTeam } from './components/UpgradeToTeam'
import css from './styles.module.css'
import type { PlanType, ProSlideType, TeamSlideType } from './types'
import { useUpgradePlanModal } from './useUpgradePlanModal'

interface Props extends ModalProps {
  planType: PlanType
  slideType?: ProSlideType | TeamSlideType
  onClose: () => void
}

export const UpgradePlanModal: React.FC<Props> = ({
  planType,
  slideType,
  onClose,
}) => {
  const {
    plan,
    carouselItems,
    activeSlideIndex,
    buttons,
    defaultIndex,
    handleSetPlan,
    handleClickCarousel,
    handleClickFeatures,
  } = useUpgradePlanModal(planType, slideType)

  return (
    <div className={clsJoin(css.upgrade_modal, ThemeColors.light)}>
      <div className={css.upgrade_modal_left}>
        <UpgradeCarousel
          activeIndex={activeSlideIndex}
          items={carouselItems}
          onSetActiveSlide={handleClickCarousel}
        />
      </div>
      <div className={css.upgrade_modal_right}>
        <ModalHeader title="Access more features" onClose={onClose} />
        <div className={css.upgrade_modal_body}>
          <SegmentedControl
            segments={buttons}
            defaultIndex={defaultIndex}
            onClick={(value) => handleSetPlan(value as PlanType)}
          />

          <div key={plan} className={css.upgrade_modal_wrapper}>
            {plan === 'team' && (
              <UpgradeToTeam
                activeIndex={activeSlideIndex}
                onSetActiveSlide={handleClickFeatures}
              />
            )}

            {plan === 'pro' && (
              <UpgradeToPro
                activeIndex={activeSlideIndex}
                onSetActiveSlide={handleClickFeatures}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
